export default __webpack_public_path__ + "static/media/7700ROUGE.3b3743f9.pdf";